import * as tslib_1 from "tslib";
import { jsS } from "@pnp/common";
import { GraphQueryableCollection, defaultPath, GraphQueryableInstance } from "./graphqueryable";
var Security = /** @class */ (function (_super) {
    tslib_1.__extends(Security, _super);
    function Security() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Security.prototype, "alerts", {
        get: function () {
            return new Alerts(this);
        },
        enumerable: true,
        configurable: true
    });
    Security = tslib_1.__decorate([
        defaultPath("security")
    ], Security);
    return Security;
}(GraphQueryableInstance));
export { Security };
var Alerts = /** @class */ (function (_super) {
    tslib_1.__extends(Alerts, _super);
    function Alerts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Alerts.prototype.getById = function (id) {
        return new Alert(this, id);
    };
    Alerts = tslib_1.__decorate([
        defaultPath("alerts")
    ], Alerts);
    return Alerts;
}(GraphQueryableCollection));
export { Alerts };
var Alert = /** @class */ (function (_super) {
    tslib_1.__extends(Alert, _super);
    function Alert() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
    * Update the properties of an Alert
    *
    * @param properties Set of properties of this Alert to update
    */
    Alert.prototype.update = function (properties) {
        return this.patchCore({
            body: jsS(properties),
        });
    };
    return Alert;
}(GraphQueryableInstance));
export { Alert };
//# sourceMappingURL=security.js.map